import { useQuery } from '@tanstack/react-query';
import { getProperties } from '../service';
import { PortfolioFilters } from '../components/sidebar-options';

function usePortfolioProperties(
    filters: PortfolioFilters,
    pageNumber: number,
    pageSize: number,
    {
        isEnabled = true,
    }: {
        isEnabled?: boolean;
    } = {}
) {
    const query = useQuery({
        queryKey: ['properties', filters, pageNumber, pageSize],
        queryFn: () => getProperties(filters, pageNumber, pageSize),
        enabled: isEnabled,
    });

    return query;
}

export { usePortfolioProperties };
